import { useEffect, useMemo, useState } from 'react';
import { buildGestaoByCodigo } from '../utils/equipe2TechFilterHelpers';

function getAuthHeaders() {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('authToken') : null;
  return token
    ? { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    : { 'Content-Type': 'application/json' };
}

export function useEquipe2GestaoFilterContext(apiBaseUrl) {
  const [gestaoList, setGestaoList] = useState([]);
  const [espMarcas, setEspMarcas] = useState([]);
  const [espTecnologias, setEspTecnologias] = useState([]);
  const [espLinks, setEspLinks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!apiBaseUrl) return undefined;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const headers = getAuthHeaders();
        const [gestaoRes, espRes] = await Promise.all([
          fetch(`${apiBaseUrl}/api/cadastros/tecnicos/gestao`, { headers }),
          fetch(`${apiBaseUrl}/api/cadastros/tecnicos/gestao/especialidades-filtro`, { headers }),
        ]);
        const [gestaoJson, espJson] = await Promise.all([gestaoRes.json(), espRes.json()]);
        if (cancelled) return;
        setGestaoList(gestaoRes.ok && gestaoJson.success ? (gestaoJson.data || []) : []);
        if (espRes.ok && espJson.success) {
          setEspMarcas(espJson.marcas || []);
          setEspTecnologias(espJson.tecnologias || []);
          setEspLinks(espJson.links || []);
        } else {
          setEspMarcas([]);
          setEspTecnologias([]);
          setEspLinks([]);
        }
      } catch {
        if (!cancelled) {
          setGestaoList([]);
          setEspMarcas([]);
          setEspTecnologias([]);
          setEspLinks([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [apiBaseUrl]);

  const gestaoByCodigo = useMemo(() => buildGestaoByCodigo(gestaoList), [gestaoList]);

  return {
    gestaoList,
    gestaoByCodigo,
    espMarcas,
    espTecnologias,
    espLinks,
    loading,
  };
}
